<div class="accessibility-menu">
  <ul class="accessibility-menu__list">
    <li>
      <div class="accessibility-menu__toggle-item">
        <brt-toggle-checkbox [data]="{label: 'Hoher Kontrast', filterKey: ''}" (state-changed)="onContrastStateChanged($event)" [initialValue]="initialHighContrastValue"></brt-toggle-checkbox>
      </div>
    </li>
    <li>
      <div class="accessibility-menu__toggle-item">
        <brt-toggle-checkbox [data]="{label: 'Graustufen', filterKey: ''}" (state-changed)="onGrayscaleChanged($event)" [initialValue]="initialGrayscaleValue"></brt-toggle-checkbox>
      </div>
    </li>
    <li>
      <div class="accessibility-menu__toggle-item">
        <brt-toggle-checkbox [data]="{label: 'Keine Animationen', filterKey: ''}" (state-changed)="onStopMovingContentChanged($event)" [initialValue]="stopMovingContent"></brt-toggle-checkbox>
      </div>
    </li>
    <li>
      <div class="accessibility-menu__toggle-item">
        <brt-toggle-checkbox [data]="{label: 'Großer Textabstand', filterKey: ''}" (state-changed)="onTextSpacingChanged($event)" [initialValue]="textSpacing"></brt-toggle-checkbox>
      </div>
    </li>
  </ul>
</div>
